import { Controller } from "@hotwired/stimulus"

// Envía el formulario de búsqueda automáticamente con debounce
// Uso: data-controller="search" en el form
//      data-action="input->search#search" en text inputs
//      data-action="change->search#search" en selects
export default class extends Controller {
  initialize() {
    this._timer = null;
  }

  search() {
    clearTimeout(this._timer);
    this.element.classList.add('is-searching');
    this._timer = setTimeout(() => {
      this.element.classList.remove('is-searching');
      const form = this.element.closest('form') ?? this.element;
      form.requestSubmit();
    }, 350);
  }
}
